import React, { useState } from 'react';
import { Html5QrcodeScanner, Html5Qrcode } from "html5-qrcode";
import axios from 'axios';

const QRScanner = () => {
  const [scanning, setScanning] = useState(false);
  const [scannerInstance, setScannerInstance] = useState(null);
  const [scannedCode, setScannedCode] = useState(null);
  const [success, setSuccess] = useState(false);

  const showSuccessMessage = () => {
    setSuccess(true);
    setTimeout(() => setSuccess(false), 30000); // 30 seconds
  };

  const startScanner = () => {
    if (scanning) return;

    const html5QrCode = new Html5Qrcode("reader");
    setScannerInstance(html5QrCode);
    setScanning(true);

    html5QrCode
      .start(
        { facingMode: "environment" },
        {
          fps: 10,
          qrbox: 250
        },
        (decodedText) => {
          console.log('Scanned:', decodedText);
          const student_id = localStorage.getItem("userId");
          const [teacher_id, program_id, semester_id, subject_id, session_id] = decodedText.split('-');

          const payload = {
            teacher_id,
            program_id,
            semester_id,
            subject_id,
            session_id,
            student_id,
          };

          axios.post('http://localhost:8081/api/mark-attendance', payload)
            .then(res => {
              setScannedCode(decodedText);
              showSuccessMessage(); // show beautiful success message
            })
            .catch(err => {
              alert(err?.response?.data?.message || 'Failed to mark attendance');
            });

          html5QrCode.stop().then(() => {
            html5QrCode.clear();
            setScanning(false);
          });
        },
        (error) => {
          // Optionally handle scan failure
        }
      )
      .catch((err) => {
        console.error("Unable to start scanning", err);
        setScanning(false);
      });
  };

  return (
    <div style={{ maxWidth: '400px', margin: '0 auto' }}>
      <h2>Scan QR Code</h2>
      {scannedCode && <h1>{scannedCode}</h1>}
      {!scanning && (
        <button onClick={startScanner} style={{ marginBottom: '1rem' }}>
          Start Scanning
        </button>
      )}
      {success && (
        <div style={{
          padding: '1rem',
          backgroundColor: '#d4edda',
          color: '#155724',
          border: '1px solid #c3e6cb',
          borderRadius: '5px',
          marginTop: '1rem'
        }}>
          ✅ Attendance marked successfully!
        </div>
      )}

      <div id="reader" style={{ width: '100%' }}></div>
    </div>
  );
};

export default QRScanner;
